import { Routes } from '@angular/router';
import { quoterGuard } from '@webapp/quoter/guards/quoter.guard';
import { IssuePolicyLayoutComponent, IssuePolicyLinkSuccessPageComponent, IssuePolicyPageComponent, IssuePolicySuccessPageComponent } from '@webapp/policies/flows/issue-policy-flow';
import { QUOTER_ROUTE_SEGMENT } from '@webapp/core';
import { clientAuthGuard } from './guards/client-auth.guard';
import { clientAccountGuard } from './guards/client-account.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: QUOTER_ROUTE_SEGMENT,
    pathMatch: 'full',
  },
  {
    path: 'ingresar',
    canActivate: [clientAccountGuard],
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@webapp/auth/routes').then(m => m.clientLoginRoutes),
      },
    ],
  },
  {
    path: 'polizas',
    loadComponent: () =>
      import('@webapp/policies/flows/issue-policy-flow').then(m => m.IssuePolicyLayoutComponent),
    children: [
      {
        path: 'nueva/:id',
        component: IssuePolicyPageComponent,
      },
      {
        path: 'nueva/:id/success',
        component: IssuePolicySuccessPageComponent,
      },
      {
        path: 'nueva/:id/link-generado',
        component: IssuePolicyLinkSuccessPageComponent,
      },
    ],
  },
  {
    path: 'dashboard',
    canActivate: [clientAuthGuard],
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/ui/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
      },
    ],
  },
 
  {
    path: 'cotizacion/:id',
    canActivate: [clientAuthGuard],
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/ui/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
      },
    ],
  },
  {
    path: 'mis-polizas',
    canActivate: [clientAuthGuard],
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/policies/ui/policy-list-page/policy-list-page.component').then(m => m.PolicyListPageComponent),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./features/policies/ui/policy-detail-page/policy-detail-page.component').then(m => m.PolicyDetailPageComponent),
      },
    ],
  },
  {
    path: 'inspections/:id/photos',
    canActivate: [clientAuthGuard],
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/inspections/ui/inspection-photos-page/inspection-photos-page.component').then(m => m.InspectionPhotosPageComponent),
      },
    ],
  },
  {
    path: 'activacion/:policyId',
    canActivate: [clientAuthGuard],
    loadChildren: () => import('@webapp/activations').then(m => m.activationFlowRoutes),
  },
  {
    path: QUOTER_ROUTE_SEGMENT,
    loadChildren: () => import('@webapp/quoter').then(() => webRoutes),
  },
  {
    path: 'qrs',
    loadChildren: () => import('@webapp/qrs').then((m) => m.routes),
  },
];
export const webRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/quoter/ui/quoter-page/quoter-page.component').then(m => m.QuoterPageComponent),
      },
    ],
  },
  {
    path: 'emision-exitosa',
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@webapp/quoter/ui/pages/quoter-success/quoter-success.component').then(m => m.QuoterSuccessComponent),
      },
    ],
  },
  {
    path: 'inspeccion-exitosa/:id',
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@webapp/quoter/ui/pages/quoter-inspection-success/quoter-inspection-success.component').then(m => m.QuoterInspectionSuccessComponent),
      },
    ],
  },
  {
    path: 'link-generado',
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@webapp/quoter/ui/pages/link-success/link-success.component').then(m => m.LinkSuccessComponent),
      },
    ],
  },
  {
    path: 'emision-error',
    loadComponent: () =>
      import('@webapp/core/ui/layouts/web-layout/web-layout.component').then(m => m.WebLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@webapp/quoter/ui/pages/quoter-error/quoter-error.component').then(m => m.QuoterErrorComponent),
      },
    ],
  },
  {
    path: ':risk',
    loadComponent: () =>
      import('@webapp/quoter/ui/pages/quoter-layout/quoter-layout.component').then(m => m.QuoterLayoutComponent),
    canActivate: [quoterGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@webapp/quoter/ui/pages/quoter-base/quoter-base.component').then(m => m.QuoterBaseComponent),
      },
    ],
  },
];